import * as React from "react"

export const ArrowBottomIcon = () => {
  return (
    <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 17.3132C7.14186 18.081 20.5443 16.0629 25.0192 1.8488" stroke="#36393A" strokeLinejoin="round" />
      <path
        d="M26.8348 6.71912L25.3296 1.00005L20.5776 4.52025"
        stroke="#36393A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
